export default function FilterIcon() {
  return (
    <>
      <path
        id='Vector'
        d='M14.6641 4.33398H10.6641'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M3.9987 4.33398H1.33203'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_3'
        d='M6.66536 6.66764C7.95403 6.66764 8.9987 5.62297 8.9987 4.33431C8.9987 3.04565 7.95403 2.00098 6.66536 2.00098C5.3767 2.00098 4.33203 3.04565 4.33203 4.33431C4.33203 5.62297 5.3767 6.66764 6.66536 6.66764Z'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_4'
        d='M14.6667 11.667H12'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_5'
        d='M5.33203 11.667H1.33203'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_6'
        d='M9.33333 14.0007C10.622 14.0007 11.6667 12.956 11.6667 11.6673C11.6667 10.3787 10.622 9.33398 9.33333 9.33398C8.04467 9.33398 7 10.3787 7 11.6673C7 12.956 8.04467 14.0007 9.33333 14.0007Z'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
